(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qc-editorial-header"]) return;
  try {
    
(()=>{let pending=false;const update=()=>{document.querySelectorAll('.qce-header').forEach(h=>h.classList.toggle('is-scrolled',window.scrollY>70));pending=false};window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update)}},{passive:true});update()})();

document.querySelectorAll('.qce-header__mobile a').forEach(link=>link.addEventListener('click',()=>link.closest('details').removeAttribute('open')));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.qce-header__mobile[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-editorial-home"] && !Shopify.designMode) return;
  try {
    
function initQuietCrisis(root){
  if(!root||root.dataset.qceInitialized)return;
  root.dataset.qceInitialized='true';
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.08});
    root.querySelectorAll('[data-qce-reveal]').forEach(el=>{el.classList.add('qce-reveal-ready');observer.observe(el)});
  }
  const battery=root.querySelector('.qce-battery');
  if(battery)battery.addEventListener('click',()=>{const open=battery.getAttribute('aria-expanded')!=='true';battery.setAttribute('aria-expanded',String(open));root.querySelector('.qce-battery__reply').textContent=open?'Still going.':''});
  const story=root.querySelector('.qce-stair-story');
  if(story&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
    story.classList.add('qce-story-motion');
    let ticking=false;
    const update=()=>{story.classList.toggle('qce-story-arrived',story.getBoundingClientRect().top<window.innerHeight*.12);ticking=false};
    const scroll=()=>{if(!story.isConnected){window.removeEventListener('scroll',scroll);return}if(!ticking){ticking=true;requestAnimationFrame(update)}};
    window.addEventListener('scroll',scroll,{passive:true});update();
  }
  const dialog=root.querySelector('.qce-lightbox');
  if(!dialog||typeof dialog.showModal!=='function')return;
  const image=dialog.querySelector('img');
  root.querySelectorAll('[data-qce-open]').forEach(button=>button.addEventListener('click',()=>{
    image.src=button.dataset.qceOpen;
    image.alt=button.querySelector('img').alt;
    dialog.showModal();
  }));
  dialog.querySelector('button').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
}
document.querySelectorAll('.qce').forEach(initQuietCrisis);
document.addEventListener('shopify:section:load',event=>initQuietCrisis(event.target.querySelector('.qce')));

  } catch(e) { console.error(e); }
})();
})();
